import { ref, computed } from 'vue'
import { useStore } from 'vuex';


export function useTitleChangeModal() {
    const store = useStore()

    const titleChangeModalVisible = ref<boolean>(false),
        selectedType = ref<string>(''),
        selectedTitle = ref<string>(''),
        selectedId = ref<string>('');

    const selectedItems = computed({
            get: () => store.getters['itemList/getSelectedItems'],
            set: (val) => store.dispatch('itemList/updateSelection', val)
          });

  const openTitleChangeModal = (item?: { id: string; title: string; type: string }) => {
    const target = item || selectedItems.value[0]
    if (target) {
      selectedType.value = target.type
      selectedTitle.value = target.title
      selectedId.value = target.id
    }
    titleChangeModalVisible.value = true
  }

  const setTitleChangeModal = (val: boolean) => {
    titleChangeModalVisible.value = val
  }

  return {
    // state
    titleChangeModalVisible,
    selectedType,
    selectedTitle,
    selectedId,
    selectedItems,

    // methods
    openTitleChangeModal,
    setTitleChangeModal,
  }
}